import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { Branches } from '@s-app/plans/plans';
@Component({
  selector: 'app-payment-method-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RadioButtonModule,
    FormsModule,
    DropdownModule,
    InputGroupModule,
    InputGroupAddonModule
  ],
  templateUrl: './payment-method-dialog.component.html',
  styleUrl: './payment-method-dialog.component.scss'
})
export class PaymentMethodDialogComponent {
  public PaymentMethod = PaymentMethod;
  public selectedPaymentMethod: PaymentMethod = PaymentMethod.Mada;
  public selectedBranch: number | null;
  dialogData: PaymentMethodDialogData;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.dialogData = config.data;
    this.selectedBranch = this.dialogData&&this.dialogData.branches?.length === 1 ? this.dialogData.branches[0].branchId : null;
  }

  initApplePay(checkoutUrl: string) {
    if (this.selectedPaymentMethod === PaymentMethod.Applepay) {
      var config = {
        sessionId: checkoutUrl, // Here you add the "SessionId" you receive from InitiateSession Endpoint.
        countryCode: 'KWT', // Here, add your Country Code.
        currencyCode: 'KWD', // Here, add your Currency Code.
        amount: this.dialogData.price, // Add the invoice amount.
        cardViewId: 'card-element',
        callback: this.confirm.bind(this),
      };

      (window as any).myFatoorahAP.init(config);
    } else {
      window.location.href = checkoutUrl;
    }
  }


  confirm(): void {
    let dialogData: PaymentMethodDialogCloseData;
    dialogData = this.selectedBranch ? { brancheID: this.selectedBranch, PaymentMethodEnum: this.selectedPaymentMethod }: { PaymentMethodEnum: this.selectedPaymentMethod }
      this.ref.close(dialogData);
  }
}
export interface PaymentMethodDialogData {
  branches?: Branches[];
  title?: string; // Plan name (e.g., "Upgrade Plan (Basic - Quarterly)")
  price: number; // Price (e.g., 240)
  currency: string; // Currency (e.g., "EGP")
  period?: string; // Time period (e.g., "Monthly", "Quarterly")
}

export interface PaymentMethodDialogCloseData {
  brancheID?: number;
  PaymentMethodEnum: PaymentMethod;
}
export enum PaymentMethod {
  MasterCard = 0,
  Mada = 2,
  Applepay = 3,
}
